module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchReport.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.transformedData,
      "paginator": true,
      "rows": 10,
      "rowsPerPageOptions": [10, 20, 50]
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No records found. Please search with date range.")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "field": "customerType",
      "header": "Customer Type",
      "sortable": true
    }
  }), _vm._v(" "), _vm._l((_vm.uniqueDates), function(date) {
    return _c('Column', {
      key: date,
      attrs: {
        "header": _vm.formatDate(date)
      },
      scopedSlots: _vm._u([{
        key: "body",
        fn: function(slotProps) {
          return [(slotProps.data[date]) ? _c('div', [_vm._v("\n              " + _vm._s(slotProps.data[date].salesCount) + " orders"), _c('br'), _vm._v("\n              Rs. " + _vm._s(slotProps.data[date].totalSales.toFixed(2)) + "\n            ")]) : _c('div', [_vm._v("\n              0 orders"), _c('br'), _vm._v("\n              Rs. 0.00\n            ")])]
        }
      }, {
        key: "footer",
        fn: function() {
          return [_c('div', [_vm._v("\n              " + _vm._s(_vm.getDateTotal(date).count) + " orders"), _c('br'), _vm._v("\n              Rs. " + _vm._s(_vm.getDateTotal(date).amount.toFixed(2)) + "\n            ")])]
        },
        proxy: true
      }], null, true)
    })
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "headerStyle": "font-weight: bold"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('div', [_vm._v("\n              " + _vm._s(slotProps.data.totalOrders) + " orders"), _c('br'), _vm._v("\n              Rs. " + _vm._s(slotProps.data.totalAmount.toFixed(2)) + "\n            ")])]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.grandTotalOrders) + " orders"), _c('br'), _vm._v("\n              Rs. " + _vm._s(_vm.grandTotalAmount.toFixed(2)) + "\n            ")])]
      },
      proxy: true
    }])
  })], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23925e78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/analysisReport/CustomerWiseSalesCount.vue
// module id = 2093
// module chunks = 0